import gql from 'graphql-tag';

export default gql`
    query GetAssetLoadNotes($loadId: Int) {
        getAssetLoadNotes(loadId: $loadId) {
            id
            notes
            createdAt
            modifiedAt
            createdUserId
            loadId
            isDeleted
            name
            userName
            email
        }
    }
`;
